// Small colored pill for a task's work-item type, resolved from the per-project
// type cache. Shared by both TaskRow variants (komfort + kompakt) and the
// Kanban card so the "Typ" cell looks the same everywhere. Renders a muted "—"
// when the task has no type assigned.

import type { ApiWorkItemType } from "@juuplan/shared";
import { softPillStyle } from "../lib/format";

interface Props {
  /** Resolved type, or null when the task has no type_id (or it's unknown). */
  type: ApiWorkItemType | null;
  /** Compact variant used inside dense rows — smaller text, tighter padding. */
  compact?: boolean;
}

export function WorkItemTypeBadge(props: Props): preact.JSX.Element {
  const { type, compact = false } = props;
  if (!type) {
    return (
      <span class="text-label text-[color:var(--color-on-surface-variant)]/60" aria-hidden="true">
        —
      </span>
    );
  }
  return (
    <span
      class={`inline-flex items-center gap-1 rounded-md font-medium truncate max-w-full ${
        compact ? "px-1.5 py-0.5 text-label" : "px-2 py-0.5 text-micro"
      }`}
      style={softPillStyle(type.color)}
      title={`Typ: ${type.name}`}
    >
      <span
        class="inline-block size-1.5 rounded-full shrink-0"
        style={{ background: type.color }}
        aria-hidden="true"
      />
      <span class="truncate">{type.name}</span>
    </span>
  );
}
